import styled from 'styled-components';

export const OfferContent = styled.div`
  background: linear-gradient(135deg, #eff6ff 0%, #faf5ff 100%);
  border: 1px solid #dbeafe;
  border-radius: 16px;
  padding: 25px;
  transform: translateZ(0);
  backface-visibility: hidden;
`;
export const OfferHeader = styled.div`
  display: flex;
  justify-content: space-between;
  .add-button {
    width: auto;
    div {
      gap: 16px;
      span {
        font-size: 20px;
      }
    }
  }
`;
export const HeaderTitle = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0px;
  color: #212529;
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const OfferIcon = styled.img``;
export const OfferCard = styled.div`
  background: #ffffffb2;
  border: 1px solid #ffffff80;
  border-radius: 14px;
  margin-top: 16px;
  overflow: visible;
`;

export const CardMain = styled.div`
  padding: 16px;
  border-radius: 14px 14px 0 0;
  overflow: hidden;
`;
export const CardMainBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  @media (max-width: 700px) {
    flex-direction: column;
  }
`;
export const MainBoxLeft = styled.div`
  display: flex;
  gap: 12px;
`;
export const BoxLeftImg = styled.img`
  width: 64px !important;
  height: 64px;
  border: 1px solid #ffffff80;
  border-radius: 10px;
`;
export const BoxLeftContent = styled.div``;
export const LeftContentTitle = styled.h3`
  font-weight: 700;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0px;
  color: #212529;
`;
export const LeftContentText = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #6c757d;
  margin-top: 4px;
`;
export const CategoryBadge = styled.div`
  height: 20px;
  max-width: auto;
  background: #f1f5f9;
  border-radius: 8px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  color: #314158;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 8px;
`;
export const CategoryBadgeIcon = styled.img``;
export const MainBoxRight = styled.div`
  @media (max-width: 430px) {
    margin-top: 8px;
  }
`;
export const BoxPrice = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  text-decoration: line-through;
  color: #90a1b9;
  text-align: right;
`;
export const BoxDiscount = styled.h5`
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: 0px;
  color: #15c7a7;
  text-align: right;
  &.black {
    color: #212529;
  }
`;
export const OrderBlockBox = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .shopping-btn {
    width: fit-content;
    background: #ffffff;
    border: 1px solid #cad5e2;
    border-radius: 10px;
    height: 38px;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0px;
    text-align: center;
    color: #e7000b;
  }
  @media (max-width: 525px) {
    flex-direction: column;
    justify-content: start;
    align-items: start;
    gap: 10px;
  }
  @media (max-width: 430px) {
    .shopping-btn {
      width: 100%;
    }
  }
`;
export const OrderBlock = styled.div`
  display: flex;
  gap: 15px;
  .view-orders-btn {
    width: fit-content;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0px;
    text-align: center;
    color: #0a0a0a;
    height: 38px;
    > div {
      gap: 8px;
    }
  }
  .create-orders-btn {
    color: #ffffff;
  }
  @media (max-width: 430px) {
    flex-direction: column;
    justify-content: start;
    align-items: start;
    gap: 10px;
    width: 100%;
    .view-orders-btn {
      width: 100%;
    }
  }
`;
export const BtnIcon = styled.img``;
export const OrderDetails = styled.div`
  display: ${(props) => (props.isOpen ? 'block' : 'none')};
  padding: 20px;
  overflow: visible;
  border-radius: 0 0 14px 14px;
`;
export const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 8px;
  transition: transform 0.3s ease;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(0deg)' : 'rotate(180deg)')};
  will-change: transform;
`;
export const OrderTitle = styled.h3`
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0px;
  color: #212529;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 6px;
`;
export const OrderFlex = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  @media (max-width: 700px) {
    flex-direction: column;
  }
`;
export const FlexLeft = styled.div``;
export const FlexTitle = styled.h4`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  color: #212529;
  margin-bottom: 6px;
`;
export const OrderTags = styled.div`
  display: flex;
  gap: 10px;
`;

export const StatusDropdownWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const TagItem = styled.div`
  width: fit-content;
  border-radius: 16px;
  background: ${({ $status }) => {
    if ($status === 'approved') return '#15c7a71a';
    if ($status === 'rejected') return '#e7000b1a';
    return '#faa11c1a';
  }};
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  color: ${({ $status }) => {
    if ($status === 'approved') return '#15c7a7';
    if ($status === 'rejected') return '#e7000b';
    return '#faa11c';
  }};
  padding: 2px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  user-select: none;
  transition: all 0.2s ease;

  ${({ $clickable, $status }) =>
    $clickable &&
    `
    &:hover {
      background: ${
        $status === 'approved'
          ? '#15c7a733'
          : $status === 'rejected'
            ? '#e7000b33'
            : '#faa11c33'
      };
      transform: translateY(-1px);
    }
    &:active {
      transform: translateY(0);
    }
  `}

  &.qty {
    background: #dbeafe;
    color: #2d6cdf;
    cursor: default;
  }
`;

export const StatusDropdown = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  min-width: 140px;
  z-index: 9999;
  overflow: hidden;
  animation: slideDown 0.2s ease;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const StatusDropdownItem = styled.div`
  padding: 10px 16px;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0px;
  color: ${({ $variant }) => ($variant === 'approve' ? '#15c7a7' : '#e7000b')};
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: ${({ $variant }) => ($variant === 'approve' ? '#15c7a70f' : '#e7000b0f')};
  }

  &:not(:last-child) {
    border-bottom: 1px solid #f1f5f9;
  }
`;

export const FlexText = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #6c757d;
  border-left: 2px solid #e2e8f0;
  padding-left: 6px;
  margin-top: 15px;
`;

export const FlexRight = styled.div``;
export const OrderDate = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: right;
  color: #6c757d;
  display: flex;
  gap: 16px;
  align-items: center;
  @media (max-width: 700px) {
    justify-content: flex-end;
  }
`;
export const OrderName = styled.div``;
export const OrderHistoryBox = styled.div`
  display: flex;
  gap: 10px;
  justify-content: end;
`;
export const OrderHistory = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0px;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  text-decoration-skip-ink: auto;
  color: #2d6cdf;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  cursor: pointer;
`;
export const HistoryIcon = styled.img``;
export const OrderEdit = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  color: #6c757d;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  cursor: pointer;
`;

export const EmptyMessage = styled.div`
  padding: 40px 20px;
  text-align: center;
  color: #6c757d;
  font-size: 14px;
  font-weight: 500;
  background: #ffffff80;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const ConfirmMessage = styled.div`
  padding: 10px 0;
  color: #212529;
  font-size: 14px;
  line-height: 1.5;
`;
export const OrderOfferDesc = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #6c757d;
  margin-bottom: 15px;
`;
export const ConfirmActions = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 20px;

  .flex-1-button {
    flex: 1;
  }

  .danger-button {
    background: #dc3545;

    &:hover {
      background: #c82333;
    }
  }
`;

export const ActionButton = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  color: ${({ $variant }) =>
    $variant === 'approve' ? '#15c7a7' : $variant === 'reject' ? '#e7000b' : '#6c757d'};
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

export const DateText = styled.p`
  font-weight: 400;
  font-size: 12px;
`;

export const DateWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 10px;
`;

export const ClockImg = styled.img`
  width: 15px;
  height: 15px;
  margin-top: -1px;
`;

const BaseButton = styled.button`
  flex: 1;
  height: 44px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
`;

export const CancelButton = styled(BaseButton)`
  background: #ffffff;
  color: #0a0a0a;
  border: 1px solid #0000001a;

  &:hover {
    background: #f8f9fa;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SubmitButton = styled(BaseButton)`
  background: linear-gradient(90deg, #2a75e8 0%, #1f406e 100%);
  color: #ffffff;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
